<template>
  <Exception type="404" />
</template>